import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Col, Row } from "reactstrap";

// eslint-disable-next-line react/prop-types
const BreadCrumb = ({ title, pageTitle }) => {

  const location = useLocation();

  useEffect(() => {
    document.title = title + " | " + process.env.REACT_APP_NAME;
  }, [location, title]);

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">{pageTitle}</h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">{pageTitle}</Link>
                </li>
                <li className="breadcrumb-item active">{title}</li>
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
